module.exports = __webpack_public_path__ + "static/img/bg-title.b4ebd47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/2020/pc/bg-title.png
// module id = pb/e
// module chunks = 70